import { Button, Modal, Stack, Typography, useTheme } from "@mui/material";
import type { DocumentDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	document: DocumentDTO;
	open: boolean;
	onClose: (result: boolean) => void;
};

export const DeleteDocumentDialog = ({ document, open, onClose }: Props) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<Modal open={open} onClose={() => onClose(false)}>
			<Stack
				bgcolor={theme.palette.common.white}
				p={2}
				borderRadius={1.6}
				gap={1.6}
				sx={{
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					minWidth: "80%",
				}}
			>
				<Typography variant="deprecatedH3">
					{t(Resources.Portfolio.List.DeleteDocumentDialog.title)}
				</Typography>
				<Typography>
					{t(Resources.Portfolio.List.DeleteDocumentDialog.description, {
						documentName: document.title,
					})}
				</Typography>
				<Stack direction="row" gap={1.6} justifyContent={"flex-end"}>
					<Button
						variant="text"
						onClick={() => onClose(false)}
						sx={{ color: theme.palette.common.black }}
					>
						{t(Resources.Portfolio.List.DeleteDocumentDialog.cancel)}
					</Button>
					<Button variant="text" onClick={() => onClose(true)}>
						{t(Resources.Portfolio.List.DeleteDocumentDialog.confirm)}
					</Button>
				</Stack>
			</Stack>
		</Modal>
	);
};
